import { Outlet } from "react-router-dom";

const StandaloneLayout = () => (
  <div className="min-h-dvh">
    <main>
      <Outlet />
    </main>
  </div>
);

export default StandaloneLayout;
